 /*
 *
 * Profile actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';
 import {User} from "../../domains/app";

export const defaultAction = createAction<number>(
  `${SLICE_NAME}/defaultAction`,
);

export const updateProfileAction = createAction<User>(
  `${SLICE_NAME}/updateProfile`
);